import type { FC } from 'react';
import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';
import type { TableColumn } from '@interstate/components/Table';

const InformationSection: FC<{ data: any; columnDefs: TableColumn[] }> = ({ data, columnDefs }) => {
    return (
        <Box display="flex" flexDirection="column" gap="6px">
            {columnDefs.map((col: any, idx: number) => (
                <Box key={idx} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="body-sm">{col.title}:</Typography>
                    <Typography variant="strong-sm">
                        {col.dataIndex && typeof col.dataIndex === 'string' && (data[col.dataIndex as keyof typeof data] || '--')}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

export default InformationSection;
